/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_CatInputs */

const en_svc_full_stack_web_apps_cat = /** @type {(inputs: Svc_Full_Stack_Web_Apps_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIPS`)
};

const ar_svc_full_stack_web_apps_cat = /** @type {(inputs: Svc_Full_Stack_Web_Apps_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#إطلاق`)
};

const bn_svc_full_stack_web_apps_cat = /** @type {(inputs: Svc_Full_Stack_Web_Apps_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIPS`)
};

const de_svc_full_stack_web_apps_cat = /** @type {(inputs: Svc_Full_Stack_Web_Apps_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIPS`)
};

const es_svc_full_stack_web_apps_cat = /** @type {(inputs: Svc_Full_Stack_Web_Apps_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIPS`)
};

const fr_svc_full_stack_web_apps_cat = /** @type {(inputs: Svc_Full_Stack_Web_Apps_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIPS`)
};

const pt_svc_full_stack_web_apps_cat = /** @type {(inputs: Svc_Full_Stack_Web_Apps_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIPS`)
};

const zh_svc_full_stack_web_apps_cat = /** @type {(inputs: Svc_Full_Stack_Web_Apps_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIPS`)
};

const tr_svc_full_stack_web_apps_cat = /** @type {(inputs: Svc_Full_Stack_Web_Apps_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIPS`)
};

const ru_svc_full_stack_web_apps_cat = /** @type {(inputs: Svc_Full_Stack_Web_Apps_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIPS`)
};

const pl_svc_full_stack_web_apps_cat = /** @type {(inputs: Svc_Full_Stack_Web_Apps_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIPS`)
};

/**
* | output |
* | --- |
* | "#SHIPS" |
*
* @param {Svc_Full_Stack_Web_Apps_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_cat = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_cat(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_cat(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_cat(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_cat(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_cat(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_cat(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_cat(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_cat(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_cat(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_cat(inputs)
	return en_svc_full_stack_web_apps_cat(inputs)
});
export { svc_full_stack_web_apps_cat as "svc_full-stack-web-apps_cat" }